import { Link, useLocation } from "wouter"
import { useRef, useEffect } from "react"

const navItems = [
  { label: "Work", href: "/work", index: "01" },
  { label: "About", href: "/about", index: "02" },
  { label: "Leadership", href: "/leadership", index: "03" },
  { label: "AI Lab", href: "/ai-lab", index: "04" },
  { label: "Writing", href: "/writing", index: "05" },
  { label: "Podcast", href: "/podcast", index: "06" },
  { label: "Contact", href: "/contact", index: "07" },
]

export default function Nav({ menuOpen, setMenuOpen, isHome, isSkill, theme, toggleTheme }) {
  const overlayRef = useRef(null)
  const [, navigate] = useLocation()

  // Reset scroll position when menu closes
  useEffect(() => {
    if (!menuOpen && overlayRef.current) {
      overlayRef.current.scrollTop = 0
    }
  }, [menuOpen])

  const handleNav = (e, href) => {
    e.preventDefault()
    if (menuOpen && href === "/") return
    setMenuOpen(false)
    navigate(href)
  }

  return (
    <>
      <nav className={`nav-bar${isHome ? " home-mode" : ""}${menuOpen ? " menu-open" : ""}`}>
        {!isSkill && (
          <Link
            href="/"
            className="nav-logo"
            onClick={(e) => { e.preventDefault(); setMenuOpen(false); navigate('/') }}
            aria-label="Home"
          >
            <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="16" fill="currentColor"/>
            </svg>
          </Link>
        )}
        <div className="nav-right">
          {!isSkill && isHome && !menuOpen && (
            <button type="button" className="nav-theme-btn" onClick={toggleTheme} aria-label="Toggle theme">
              <span className="nav-theme-icon" data-theme={theme} />
            </button>
          )}
          {!isSkill && (
            <button type="button" className="nav-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? "Close" : "Menu"}
            </button>
          )}
        </div>
      </nav>

      {/* Home-only inline nav, pinned to the right edge. The home hero
          sits bottom-left and the rest of the canvas is empty, so the
          links can live in the open instead of behind a button. Every
          other page keeps the Menu button and overlay exactly as before.
          Hidden below 769px, where the Menu button takes over again —
          see the media queries on .home-nav. */}
      {isHome && !isSkill && !menuOpen && (
        <nav className="home-nav" aria-label="Sections">
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="home-nav-link"
              onClick={(e) => handleNav(e, item.href)}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}

      <div ref={overlayRef} className={`menu-overlay ${menuOpen ? "open" : ""}`}>
        <ul className="menu-list">
          {navItems.map((item) => (
            <li key={item.href}>
              <Link
                href={item.href}
                className="menu-link"
                onClick={(e) => handleNav(e, item.href)}
              >
                <span>
                  <span className="menu-link-index">{item.index}&nbsp;&nbsp;</span>
                  {item.label}
                </span>
                <span className="menu-link-arrow">→</span>
              </Link>
            </li>
          ))}
        </ul>

        <div className="menu-footer">
          <div className="menu-footer-role">
            <strong>Rice Tseng</strong>
            Design Director · OKX · Singapore
          </div>
          <div className="menu-social">
            <a href="https://x.com/ricetseng" target="_blank" rel="noopener noreferrer">X</a>
            <a href="https://linkedin.com/in/ricetseng" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="https://medium.com/@ricetseng_0820" target="_blank" rel="noopener noreferrer">Medium</a>
          </div>
        </div>
      </div>
    </>
  )
}
